import React, { Component } from "react";
import Image from '../global/Image';
import Cinemagraph from '../global/Cinemagraph';

export default class PageSplash extends Component {
  	
	render () {
		
		let block = this.props.block;
		
		if (block) {
			
			if (window.innerHeight > window.innerWidth && (block.pcin_src !== false || block.pimg_src !== false)) {
				
				return (
					
					<div id={block.id} className={'c-page__block c-page__block--space-' + block.space + ' c-page__block--splash-load-effect'}>
					
						<div className={'c-splash c-splash--' + block.style}>
						
							{block.pcin_src !== false &&
								<Cinemagraph src={block.pcin_src} />
							}
							
							{block.pcin_src === false &&
								<Image src={block.pimg_src} srcset={block.pimg_srcset} />
							}
							
						</div>
						
					</div>
					
				)
		
			} else {
				
				return (
					
					<div id={block.id} className={'c-page__block c-page__block--space-' + block.space + ' c-page__block--splash-load-effect'}>
						
						<div className={'c-splash c-splash--' + block.style}>
						
							{block.lcin_src !== false &&
								<Cinemagraph src={block.lcin_src} />
							}
							
							{block.lcin_src === false &&
								<Image src={block.limg_src} srcset={block.limg_srcset} />
							}
							
						</div>
						
					</div>
				
				)
						
			}
									
		} else {
			
			return null;
		
		}
	}
}
